// @ts-nocheck
import { useEffect, useState } from 'react'
import { Button } from "@/components/ui/button"

import SidePanel from './SidePanel'
import { AdminPermissionList } from './Admins/AdminPermissionList'
import useAdminStore from '@store/adminStore';
import { useOutletContext } from 'react-router-dom';
import { Title } from '@radix-ui/react-toast';
import { useAuth } from '@/auth/clerkShim';

export default function AdminModal({ open, onClose, onSubmit, title = 'Admins', subtitle, data }) {
  const { getToken } = useAuth();
  const { leagueName } = useOutletContext() as any;
  const { admins, getAdminsByLeagueName } = useAdminStore((state: any) => ({
    admins: state.admins,
    getAdminsByLeagueName: state.getAdminsByLeagueName(getToken),
  }));

  useEffect(() => {
    console.log('AdminModal::leagueName: ', leagueName);
    getAdminsByLeagueName(leagueName, (res) => {
      console.log('getAdminByLeagueName::result: ', res);
      // setAdmins(res);
    });
  }, []);
  const handleSubmitSuccess = (values: any) => {
    console.log('handleSubmitSuccess', values);
    onSubmit(values);
    onClose();
  }

  console.log('AdminModal::admins: ', admins);

  return (
    <SidePanel
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      description="Manage who can administer this. Click save when you're done."
    >
      <AdminPermissionList onSubmitSuccess={handleSubmitSuccess} adminList={admins} data={data} />
    </SidePanel>
  )
}

